/* 햄버거 패널 안에서 언어를 바꿔도 패널이 닫히지 않게 한다.
 *
 * ─── 왜 필요한가 ───────────────────────────────────────────────────────────
 *
 * 언어 전환은 /localization 으로 POST 하는 폼 제출이라 페이지가 통째로 다시
 * 뜬다. 패널은 <details> 라서 새 문서에서는 닫힌 상태로 시작한다 — 고객이
 * 보기엔 "언어를 눌렀더니 메뉴가 닫혔다" 가 된다.
 *
 * 그래서 제출 직전에 표시를 남기고, 다시 그려진 문서에서 그 표시를 보고 패널을
 * 도로 연다. sessionStorage 를 쓰는 이유는 탭을 닫으면 같이 사라져야 하기
 * 때문이다. localStorage 면 며칠 뒤 방문에도 메뉴가 열린 채 뜬다.
 *
 * ─── 왜 details.open = true 로 끝내지 않는가 ───────────────────────────────
 *
 * 패널은 열릴 때 menu-opening 클래스와 포커스 가둠(trapFocus)이 함께 걸린다.
 * open 만 켜면 애니메이션과 포커스 처리가 빠진 반쪽 상태가 된다. 테마가 쓰는
 * openMenuDrawer() 를 그대로 부른다 — 여는 경로를 하나로 둔다.
 */
(function () {
  var FLAG = 'tg_drawer_open';

  function markBeforeSubmit() {
    var forms = document.querySelectorAll('.tg-lang--drawer');
    for (var i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', function () {
        try { sessionStorage.setItem(FLAG, '1'); } catch (e) {}
      });
    }
  }

  function reopenIfFlagged() {
    var flagged;
    try { flagged = sessionStorage.getItem(FLAG); } catch (e) { return; }
    if (!flagged) return;
    try { sessionStorage.removeItem(FLAG); } catch (e) {}

    var drawer = document.querySelector('header-drawer');
    if (!drawer) return;
    var details = drawer.querySelector('details');
    var summary = details && details.querySelector('summary');
    if (!details || !summary) return;

    /**
     * 커스텀 엘리먼트가 아직 업그레이드되지 않았을 수 있다. openMenuDrawer 가
     * 생길 때까지 몇 프레임만 기다린다. 끝내 없으면 아무것도 하지 않는다 —
     * 반쪽으로 열어두는 것보다 닫힌 채로 두는 편이 낫다.
     */
    var tries = 0;
    (function attempt() {
      if (typeof drawer.openMenuDrawer === 'function') {
        details.open = true;
        drawer.openMenuDrawer(summary);
        return;
      }
      if (++tries > 20) return;
      requestAnimationFrame(attempt);
    })();
  }

  function init() {
    markBeforeSubmit();
    reopenIfFlagged();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
